<template>
  <div class="goods-image">
    <div
      v-show="show"
      class="large"
      :style="[
        {
          /*  backgroundImage: `url(${
            imgSrc.src ? imgSrc.src : booksImg[currIndex]?.url
          })`, */
          backgroundImage: `url(${
            imgSrc.src
              ? imgSrc.src.replace(/\\/g, '/')
              : booksImg[currIndex]?.url
          })`,
        },
        largePosition,
      ]"
    ></div>
    <div class="middle" ref="target">
      <img v-if="booksImg.length" :src="booksImg[currIndex].url" alt="" />
      <img v-else :src="imgSrc.src" alt="" />
      <div v-show="show" class="layer" :style="layerPosition"></div>
    </div>
    <ul class="small">
      <li
        v-for="(img, i) in booksImg"
        :key="img"
        :class="{ active: i === currIndex }"
      >
        <img @mouseenter="changeImg(i, img.url)" v-lazy="img.url" alt="" />
      </li>
    </ul>
  </div>
</template>

<script>
import { reactive, ref, watch } from "vue";
import { useMouseInElement } from "@vueuse/core";
export default {
  name: "BookImg",
  props: {
    booksImg: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    //当前预览图索引
    const currIndex = ref(0);
    const imgSrc = reactive({
      src: "",
    });

    //显示大图和遮罩层控制
    const show = ref(false);
    //遮罩层坐标
    const layerPosition = reactive({
      left: 0,
      right: 0,
    });
    //大图的背景定位（css）
    const largePosition = reactive({
      backgroundPositionX: 0,
      backgroundPositionY: 0,
    });

    //useMouseInElement得到基于左上角坐标定位
    const target = ref(null);
    const { elementX, elementY, isOutside } = useMouseInElement(target);
    watch([elementX, elementY, isOutside], () => {
      show.value = !isOutside.value;
      const position = { x: 0, y: 0 };
      if (elementX.value < 100) position.x = 0;
      else if (elementX.value > 300) position.x = 200;
      else position.x = elementX.value - 100;

      if (elementY.value < 100) position.y = 0;
      else if (elementY.value > 300) position.y = 200;
      else position.y = elementY.value - 100;
      //样式赋值
      layerPosition.left = position.x + "px";
      layerPosition.top = position.y + "px";
      largePosition.backgroundPositionX = -2 * position.x + "px";
      largePosition.backgroundPositionY = -2 * position.y + "px";
      //console.log(largePosition);
    });

    const changeImg = (i, url) => {
      (currIndex.value = i), (imgSrc.src = url);
    };
    return {
      currIndex,
      show,
      layerPosition,
      largePosition,
      target,
      imgSrc,
      changeImg,
    };
  },
};
</script>

<style lang="less" scoped>
.goods-image {
  width: 480px;
  height: 400px;
  position: relative;
  //display: flex;
  z-index: 500;
  .large {
    position: absolute;
    top: 15px;
    left: 427px;
    width: 400px;
    height: 400px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-repeat: no-repeat;
    background-size: 800px 800px;
    background-color: #f8f8f8;
  }
  .middle {
    width: 400px;
    height: 400px;
    margin-top: 15px;
    margin-left: 15px;
    position: relative;
    cursor: move;
    img {
      width: 400px;
      height: 400px;
    }
    .layer {
      width: 200px;
      height: 200px;
      background: rgba(0, 0, 0, 0.2);
      left: 0;
      top: 0;
      position: absolute;
    }
  }
  .small {
    display: flex;
    margin-top: 15px;
    margin-left: 15px;
    justify-content: space-between;
    width: 400px;
    height: 100px;
    li {
      width: 68px;
      height: 68px;

      img {
        width: 68px;
        height: 68px;
      }
      cursor: pointer;
      &:hover,
      &.active {
        border: 2px solid @shColor;
      }
    }
  }
}
</style>
